export const ADMIN_LOG_WINDOWS = ['1h', '24h', '7d', '30d'] as const;
export const ADMIN_LOG_COMPONENTS = [
  'frontend',
  'api_worker',
  'pixel_worker',
  'batch_worker',
] as const;

export type AdminLogWindow = (typeof ADMIN_LOG_WINDOWS)[number];
export type AdminLogComponent = (typeof ADMIN_LOG_COMPONENTS)[number];

export interface AdminLogSearch {
  signature?: string;
  trace_id?: string;
  component?: AdminLogComponent;
  window?: AdminLogWindow;
}

export const isAdminLogSignature = (value: string): boolean => /^[0-9a-f]{16}$/i.test(value);
export const isAdminLogComponent = (value: string): value is AdminLogComponent => (
  ADMIN_LOG_COMPONENTS.includes(value as AdminLogComponent)
);
const isTraceId = (value: string): boolean => /^[A-Za-z0-9._-]{1,64}$/.test(value);

/**
 * Keep alert-email deep links strict and bounded before they reach the logs API.
 * The API remains authoritative; this only prevents malformed URL state from
 * unexpectedly opening an unfiltered stream in the browser.
 */
export function parseAdminLogSearch(search: Record<string, unknown>): AdminLogSearch {
  const rawSignature = typeof search.signature === 'string' ? search.signature : '';
  const rawTrace = typeof search.trace_id === 'string' ? search.trace_id : '';
  const rawComponent = typeof search.component === 'string' ? search.component : '';
  const rawWindow = search.window === '1d' ? '24h' : search.window;

  return {
    signature: isAdminLogSignature(rawSignature) ? rawSignature.toLowerCase() : undefined,
    trace_id: isTraceId(rawTrace) ? rawTrace : undefined,
    component: isAdminLogComponent(rawComponent) ? rawComponent : undefined,
    window: ADMIN_LOG_WINDOWS.includes(rawWindow as AdminLogWindow)
      ? (rawWindow as AdminLogWindow)
      : undefined,
  };
}
